// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"richText_wrapper__8whEe","toolbar":"richText_toolbar__3OaAR","editor":"richText_editor__2rP0A"};